import React, {useState} from 'react';
import {
  StyleSheet,
  View,
  Image,
  ImageStyle,
  TextStyle,
  ViewStyle,
  useWindowDimensions,
  Pressable,
} from 'react-native';
import {getAuthData} from 'redux/selectors/authSelector';
import {useSelector} from 'react-redux';
import {spacing} from 'theme/Units';
import colors from 'theme/Colors';
import {Icon, Text} from 'ui-kits';
import {useResponsiveStyles} from 'hooks/useResponsiveStyles';
import {defaultUserProfile, mobileViewportWidth} from 'constants/DefaultValues';
import {SideNavbar} from './SideNavbar';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {RootNavigatorParams} from 'navigation/Routes';

export function Header(props: NativeStackScreenProps<RootNavigatorParams>) {
  const userInfo = useSelector(getAuthData);
  const styles = useResponsiveStyles<styleType>(baseStyle, responsiveStyle);
  const {width} = useWindowDimensions();
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

  return (
    <View style={styles.header}>
      <Image
        source={
          width > mobileViewportWidth
            ? require('assets/images/logo_black@2x.png')
            : require('assets/images/logo_white.png')
        }
        style={styles.logo}
      />
      <View style={styles.optionsWrapper}>
        <View style={styles.ai_logo}>
          <Icon type="ai_search" size={40} />
        </View>
        <Pressable onPress={() => setDropdownOpen(p => !p)}>
          <Image
            source={{
              uri: `${
                userInfo?.profile_photo_url ?? defaultUserProfile
              }?${new Date().getTime()}`,
            }}
            style={styles.profile}
          />
        </Pressable>
        <Text style={styles.name}>
          {userInfo?.first_name} {userInfo?.last_name}
        </Text>
        <Pressable onPress={() => setDropdownOpen(p => !p)}>
          <View style={styles.ai_logo}>
            <Icon type="cheveron_down" size={16} />
          </View>
        </Pressable>

        {dropdownOpen ? (
          <View style={styles.dropDownWrapper}>
            <SideNavbar {...props} />
          </View>
        ) : null}
      </View>
    </View>
  );
}
type styleType = {
  logo: ImageStyle;
  profile: ImageStyle;
  name: TextStyle;
  optionsWrapper: ViewStyle;
  header: ViewStyle;
  dropDownWrapper: ViewStyle;
  ai_logo: ViewStyle;
};
const baseStyle: styleType = StyleSheet.create({
  ai_logo: {
    display: 'flex',
  },
  dropDownWrapper: {
    position: 'absolute',
    top: '140%',
    right: -12,
    width: 320,
  },
  logo: {
    width: 90,
    height: 54,
    resizeMode: 'contain',
  },
  profile: {
    width: 40,
    height: 40,
    resizeMode: 'cover',
    borderRadius: 999,
  },
  name: {
    fontSize: 20,
    fontWeight: 500,
  },
  optionsWrapper: {
    flexDirection: 'row',
    gap: spacing['4'],
    alignItems: 'center',
  },
  header: {
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: spacing['8'],
    paddingVertical: spacing['2'],
    backgroundColor: colors.palette.white,
    borderBottomWidth: 1,
    borderColor: colors.palette.stroke,
  },
});

const responsiveStyle: Record<number, Partial<styleType>> = {
  [mobileViewportWidth]: {
    dropDownWrapper: {
      position: 'absolute',
      top: '140%',
      right: -12,
      width: 250,
    },
    header: {
      paddingHorizontal: spacing['4'],
      paddingVertical: spacing['2'],
      backgroundColor: colors.palette.brandBlue,
      borderWidth: 0,
    },
    logo: {
      height: 27,
      width: 46,
    },
    ai_logo: {
      display: 'none',
    },
    profile: {
      height: 30,
      width: 30,
    },
    name: {
      display: 'none',
    },
  },
};
